import api from 'flavours/glitch/api';
import { isStandalone } from 'flavours/glitch/features/standalone/auth';

export async function logOut() {
  // In standalone mode there is no backend session to destroy; send the user
  // to the logout page, which clears the local OAuth/state and returns to login.
  if (isStandalone()) {
    window.location.href = '/logout';
    return;
  }

  try {
    const response = await api(false).delete<{ redirect_to?: string }>(
      '/auth/sign_out',
      { headers: { Accept: 'application/json' }, withCredentials: true },
    );

    if (response.status === 200 && response.data.redirect_to)
      window.location.href = response.data.redirect_to;
    else
      console.error(
        'Failed to log out, got an unexpected non-redirect response from the server',
        response,
      );
  } catch (error) {
    console.error('Failed to log out, response was an error', error);
  }
}
